import { FormControl} from '@angular/forms';
import { ReplyTypeMap } from 'src/app/libs/proto/forum_pb';

export class NewPostForm {
  message: string;
  replytypesList: Array<ReplyTypeMap[keyof ReplyTypeMap]>;
  topicid: string;
}
